import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CrmEmptyStateProps {
  message: string;
  /** Hidden on phones by default: the list pane occupies the screen there. */
  mobileHidden?: boolean;
  children?: ReactNode;
}

export function CrmEmptyState({ message, mobileHidden = true, children }: CrmEmptyStateProps) {
  return (
    <div
      className={cn(
        "h-full flex-col items-center justify-center gap-3 p-8 text-center text-sm text-slate-400",
        mobileHidden ? "hidden md:flex" : "flex"
      )}
    >
      <p>{message}</p>
      {children}
    </div>
  );
}
